import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Check, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(r.data.payment_status);
        if (r.data.payment_status === "paid") { clear(); return; }
      } catch {}
      if (attempts < 15 && !cancelled) setTimeout(() => setAttempts((a) => a + 1), 2000);
    };
    tick();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid, attempts]);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-success-page">
      {status === "paid" ? (
        <>
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full border border-gold text-gold mb-6"><Check size={28} /></div>
          <h1 className="font-display text-4xl text-gold mb-4">Wrapped with Care</h1>
          <p className="text-parchment/80 italic mb-8">Thank you. A quiet confirmation is on its way. Your piece will be gently packed and posted shortly.</p>
          <Link to="/shop" className="btn-outline">Return to the Cabinet</Link>
        </>
      ) : (
        <>
          <Loader2 className="mx-auto animate-spin text-gold mb-4" size={32} />
          <h1 className="font-display text-3xl text-gold mb-2">Confirming your order…</h1>
          <p className="text-parchment/70 italic">One moment while the ledger updates.</p>
        </>
      )}
    </div>
  );
}
